import security from 'stores/security';
import API from 'utils/API';
import http from 'utils/http';
import { PlaidBankCardItem } from './types';

export function bindCardStep1(publicToken: string) {
    return http.get<{
        item_id: string;
        items: PlaidBankCardItem[];
    }>(API.TRADE.funding.bindCardStep1(), {
        params: {
            public_token: publicToken,
            customer_id: security.currentCustomerId
        }
    });
}
